import type { ReactNode } from 'react'
import { statusLabel, statusTone } from './format'

export const focus = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-glow'
export const inp = `min-h-[40px] rounded-lg border border-ink-400 bg-ink-800 px-3 text-paper ${focus}`
export const area = `rounded-lg border border-ink-400 bg-ink-800 px-3 py-2 text-paper ${focus}`
export const lbl = 'flex flex-col gap-1.5 text-[13px] font-semibold text-paper/70'
export const btn = `inline-flex min-h-[40px] items-center justify-center rounded-lg border border-ink-400 px-4 text-[13px] font-semibold text-paper hover:bg-ink-600 disabled:opacity-50 ${focus}`
export const btnPrimary = `inline-flex min-h-[40px] items-center justify-center rounded-lg bg-amber-glow px-4 text-[13px] font-bold text-ink-900 hover:bg-amber-deep disabled:opacity-50 ${focus}`
export const card = 'rounded-xl border border-ink-500 bg-ink-700 p-5'
export const h2 = 'text-[11px] font-bold uppercase tracking-[0.14em] text-paper-faint'

const TONE: Record<ReturnType<typeof statusTone>, string> = {
  action: 'bg-amber-wash text-amber-glow ring-amber-glow/40',
  live: 'bg-radar-green/10 text-radar-green ring-radar-green/40',
  bad: 'bg-radar-red/10 text-radar-red ring-radar-red/40',
  wait: 'bg-ink-600 text-paper-dim ring-ink-400',
  done: 'bg-ink-600 text-paper-faint ring-ink-400',
}

export function StatusChip({ status }: { status: string }) {
  return (
    <span className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-[12px] font-semibold ring-1 ${TONE[statusTone(status)]}`}>
      {statusLabel(status)}
    </span>
  )
}

/** An in-page modal: Escape closes it unless it is busy. */
export function Dialog({ title, onClose, busy, children, onSubmit }: {
  title: string
  onClose: () => void
  busy?: boolean
  children: ReactNode
  onSubmit: (e: React.FormEvent) => void
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onKeyDown={(e) => { if (e.key === 'Escape' && !busy) onClose() }}>
      <form role="dialog" aria-modal="true" aria-label={title} onSubmit={onSubmit}
            className="flex max-h-full w-full max-w-lg flex-col gap-4 overflow-y-auto rounded-xl border border-ink-500 bg-ink-700 p-5">
        <h2 className="font-serif text-[20px] font-medium">{title}</h2>
        {children}
      </form>
    </div>
  )
}

export function ErrorLine({ text }: { text: string | null }) {
  return text ? <p role="alert" className="text-[13px] text-radar-red">{text}</p> : null
}
